// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PERSON_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        personIndexPage: action.personIndexPage
      };
    },
    PERSON_INDEX_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexPage
      };
    },
    PERSON_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
